import { useAllSalesQualifiedQuery } from '../../../shared';
import moment from 'moment';

export function useOutdatedSql(agentId?: string) {
  const {data} = useAllSalesQualifiedQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
    },
    skip: !agentId
  })

  return data?.allSalesQualified?.data.filter(c => moment(c.followUpDate).isBefore(moment().startOf('day')))
}
